<template>
  <div id="app">
    <ParticlesBackground />
    <HeaderView @change-language="changeLanguage" :language="currentLanguage" />
    <main class="main-content">
    <router-view :language="currentLanguage" />
    </main>
  </div>
</template>

<script>
import HeaderView from './components/HeaderView.vue';
import ParticlesBackground from './components/ParticlesBackground.vue';

export default {
  name: 'App',
  components: {
    HeaderView,
    ParticlesBackground
  },
  data() {
    return {
      currentLanguage: 'zh-CN' // 默认语言为中文
    };
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = lang; // 更新当前语言
    }
  }
};
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  overflow: hidden;
  background:
      linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
      url('~@/assets/intro-bg.jpeg') no-repeat center top;
  background-attachment: fixed;
  background-size: cover;
  text-shadow: 
    1px 1px 2px rgba(0, 0, 0, 0.8),   /* 第一层：最靠近文字 */
    2px 2px 4px rgba(0, 0, 0, 0.6),   /* 第二层：稍微外扩 */
    3px 3px 6px rgba(0, 0, 0, 0.4);   /* 第三层：最外层柔和阴影 */
}

#app {
  position: relative;
  color: #fff;
  font-family: 'Lora', serif;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  z-index: 1;
}

.main-content {
  flex: 1; /* 占满剩余空间 */
  width: 100%;
  margin-top: 100px;
  padding-bottom: 60px;
  box-sizing: border-box;
  overflow-y: auto;
  height: calc(100vh - 100px); /* 计算剩余高度 */
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.7);
}

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.5) rgba(0, 0, 0, 0.3);
}

</style>
